import {
  DocumentsApi,
  BusinessDiligenceApi,
  ProfilingApi,
  VerificationsApi,
} from '@clearbanc/diligence-sdk';
import axios from 'axios';
import { retrieveAccessToken } from '@/utils/auth0';
import { ENV } from '../../config/app-env';

const baseURL = ENV.DILIGENCE_SERVICE_URL;

const dcAxiosClient = axios.create({ baseURL });

dcAxiosClient.interceptors.request.use(async (config) => {
  if (config.url?.includes('user-invites')) {
    return config;
  }

  const token = await retrieveAccessToken();

  if (token && config.headers) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const diligenceService = new DocumentsApi(
  {
    basePath: baseURL,
    isJsonMime: () => true,
  },
  undefined,
  dcAxiosClient,
);

export const businessDiligenceApi = new BusinessDiligenceApi(
  {
    basePath: baseURL,
    isJsonMime: () => true,
  },
  undefined,
  dcAxiosClient,
);

export const profilingApi = new ProfilingApi(
  {
    basePath: baseURL,
    isJsonMime: () => true,
  },
  undefined,
  dcAxiosClient,
);

export const verificationsApi = new VerificationsApi(
  {
    basePath: baseURL,
    isJsonMime: () => true,
  },
  undefined,
  dcAxiosClient,
);
